import validateLegalPersonFullName from "./validate.legal.person.full.name";
import validateLegalPersonShortName from "./validate.legal.person.short.name";
import validateNaturalPersonLastName from "./validate.natural.person.last.name";
import validateNaturalPersonFirstName from "./validate.natural.person.first.name";
import validateLatinNameName from "./validate.latin.name";
import validateITN from "./validate.ITN";
import validateRRC from "./validate.RRC";

const counterPartyValidatorSetup = {

  rules: {
    legalPersonFullName(input) {
      if (input.is("[name='fullName'")) {
        return validateLegalPersonFullName.validate(input.val());
      }
      return true;
    },
    legalPersonLatinName(input) {
      if (input.is("[name='latinName'")) {
        return validateLatinNameName.validate(input.val());
      }
      return true;
    },
    legalPersonShortName(input) {
      if (input.is("[name='shortName'")) {
        return validateLegalPersonShortName.validate(input.val());
      }
      return true;
    },
    naturalPersonLastName(input) {
      if (input.is("[name='lastName'")) {
        return validateNaturalPersonLastName.validate(input.val());
      }
      return true;
    },
    naturalPersonFirstName(input) {
      if (input.is("[name='firstName'")) {
        return validateNaturalPersonFirstName.validate(input.val());
      }
      return true;
    },
    ITN(input) {
      if (input.is("[name='ITN'")) {
        return validateITN.validate(input.val());
      }
      return true;
    },
    RRC(input) {
      if (input.is("[name='RRC'")) {
        return validateRRC.validate(input.val());
      }
      return true;
    },
  },
  messages: {
    legalPersonFullName: validateLegalPersonFullName.message,
    legalPersonShortName: validateLegalPersonShortName.message,
    naturalPersonLastName: validateNaturalPersonLastName.message,
    naturalPersonFirstName: validateNaturalPersonFirstName.message,
    legalPersonLatinName: validateLatinNameName.message,
    ITN: validateITN.message,
    RRC: validateRRC.message,
  }
};

export default counterPartyValidatorSetup;
